module.exports = __webpack_public_path__ + "static/media/faq6.923eb036.png";